import React, { Fragment, Component } from 'react'
import { Line } from 'react-chartjs-2'
import { connect } from "react-redux"

class Chart extends Component {
    render() {
        const { name, timestamps } = this.props.item;
        return (
            <Fragment>
                {name}
                <Line data={{
                    labels: timestamps.map(e => e.ts ? new Date(e.ts).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' }) : 0),
                    type: 'line',
                    datasets: [{
                        label: `buy`,
                        data: timestamps.map(e => e.buyingPrice),
                        backgroundColor: '#228B22',
                        borderColor: '#228B22',
                        fill: false,
                        lineTension: 0.2,
                        pointBorderWidth: 3,
                    },
                    {
                        label: `sell`,
                        data: timestamps.map(e => e.sellingPrice),
                        backgroundColor: '#ff6384',
                        borderColor: '#ff6384',
                        fill: false,
                        lineTension: 0.2, 
                        pointBorderWidth: 3,
                    }]
                }} 
                height={160}
                options={{
                    responsive:true
                }}/>
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        item: state
    };
}

export default connect(mapStateToProps)(Chart)


// WEBPACK FOOTER //
// ./src/ui/chart/index.js